import { List } from 'immutable'
import ACCESS from 'utils/Access'

export const hasConversationAccess = (participants = List(), currentUser) => {

  return ACCESS.isAdmin()
      || ACCESS.hasAnyScope('convo-ALL')
      || !ACCESS.hasAnyScope('convo-ONLY_MINE', 'convo-WITH_NO_PARTICIPANTS', 'convo-ALL')
      || participants.includes(currentUser.id)
      || (participants.isEmpty() && ACCESS.hasAnyScope('convo-WITH_NO_PARTICIPANTS'))
}

export const ensureIsAdmin = (Component) => (props) => {
  if (ACCESS.isAdmin() || ACCESS.isVideoAdmin()) {
    return <Component {...props} />
  } else {
    window.location.replace('/')
    return null
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/access/helpers.js